import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstGr0: [],
        gr0: {},
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getGr0(state) {
            return state.gr0
        },
        getGr0grade(state) {
            return state.gr0.gr0grade
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
    },
    mutations: {
        set(state, gr0) {
            state.gr0 = gr0
            if (gr0)
                state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.gr0 = { lstGr1: [] }
        },
        setParamsDataTable(state, payload) {
            state.lstGr0 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setGr0(state, gr0) {
            state.gr0 = gr0
        },
        setLstGr0(state, lstGr0) {
            state.lstGr0 = lstGr0
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, { gr0grade }) {
            commit("setLoading", true)
            commit("initForm")
            let payload = await this._vm.$axios.get(`/Products/SizeGrid/Find/${gr0grade}`)
                .then(response => {
                    let gr0 = Utils.ValidateAxiosResponse(response.data);
                    commit("set", gr0)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        },
        async save({ commit, dispatch, getters }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payout = await this._vm.$axios.post("/Products/SizeGrid/Save", getters.getGr0)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setGr0", { lstGr1: [] })
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payout
        },
        async delete({ dispatch, getters }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Products/SizeGrid/Delete/${getters.getGr0grade}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/grades-de-tamanho")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async search({ commit, dispatch, getters }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")
            let payload = await this._vm.$axios.get(`/Products/SizeGrid/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstGr0", [])
                    commit("setSearch", "")
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        },
        async findList({ commit, dispatch }){
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando grades de tamanhos", indeterminate: true }, { root: true })
			let lstGr0 = await this._vm.$axios.get("/Products/SizeGrid/FindList")
			.then(response => {
				let lstGr0 = Utils.ValidateAxiosResponse(response.data);
                commit("setLstGr0", lstGr0 )
                return lstGr0
			}).catch(error => {
                commit("setLstGr0", [] )
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return lstGr0
		},
    }
}